import 'jscroll';

/**
 * Will create an infiniteScroll container for the ratings inside a modal
 * @param $element
 * @param VerivoxRating
 */
export default ($element, VerivoxRating) => {

    function reviewsCountBiggerAs(total) {
        let countReviews = $('#scroll .rating-row').length;
        $('.review-count .pagesize').text(countReviews);

        if (countReviews >= total) {
            $('.review-count .pagesize').text(total);

            return true;
        }

        return false;
    }

    let spinner   = '<div class="text-center infinite-load spin"><img src="/images/icons/waiting.svg"></div>';
    let isLoading = false;
    let total     = VerivoxRating.getTotalReviews();

    // detect when scrolled to bottom
    $element.on('scroll', elm => {
        if (elm.target.scrollTop + elm.target.clientHeight >= (elm.target.scrollHeight - 20)) {

            if (isLoading) {
                return;
            }

            if(reviewsCountBiggerAs(total)) {
                return false;
            }

            let requestUrl = VerivoxRating.addPage().buildUrl();
                requestUrl += `html=true&total=${total}`;

            $.ajax({
                type: 'post',
                url: requestUrl,
                beforeSend: () => {
                    if (! isLoading) {
                        $element.append(spinner);
                    }
                    isLoading = true;
                },
                success: (data) => {
                    $element.append(data);

                    if(reviewsCountBiggerAs(total)) {
                        return false;
                    }
                },
                complete: () => {
                    isLoading = false;
                    $('.infinite-load.spin').remove();
                }
            });
        }
    });
};
